import { Dispatch, SetStateAction, useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import { isValidInput } from "../../utils/validations";
import useTranslation from "../../hooks/traslation";

const RolesListTopbar = ({
  setDebouncedSearchTerm,
}: {
  setDebouncedSearchTerm: Dispatch<SetStateAction<string>>;
}) => {
  const navigate = useNavigate();
  const translation = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              placeholder={translation.user.SearchHere}
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </Box>
        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-subadmin/roles/add")}
          >
            <AddIcon /> {translation.main.addRole}
          </Button>
        </div>
      </div>
    </>
  );
};

export default RolesListTopbar;
